module.exports = __webpack_public_path__ + "img/home-logo-pi_tc.60245c7a.png";